import { render } from "./invoice-filter.vue?vue&type=template&id=c3bf68a6"
import script from "./invoice-filter.vue?vue&type=script&lang=js"
export * from "./invoice-filter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__